<template>
    <div class="material">
        <el-collapse v-model="activeNames">
            <el-collapse-item title="功能组件" name="1">
                <div class="basics">
                    <draggable class="list" v-model="materialList" :sort="true" :scroll="true" :group="{ name: 'renderer', pull: 'clone', put: false }" ghostClass="ghost-view">
                        <div class="item" @click="pushComponent(item)" v-for="(item, index) in materialList" :key="index" :id="index.name">
                            <div class="renderer-status">
                                <span>释放鼠标将组件添加到此处</span>
                            </div>
                            <div class="material-status">
                                <i :class="item.icon"></i>
                                {{item.title}}
                            </div>
                        </div>
                    </draggable>
                </div>
            </el-collapse-item>

            <el-collapse-item title="营销组件" name="2">
                <div class="basics">
                    <draggable class="list" v-model="otherList" :sort="true" :scroll="true" :group="{ name: 'renderer', pull: 'clone', put: false }" ghostClass="ghost-view">
                        <div class="item" @click="pushComponent(item)" v-for="(item, index) in otherList" :key="index" :id="index.name">
                            <div class="renderer-status">
                                <span>释放鼠标将组件添加到此处</span>
                            </div>
                            <div class="material-status">
                                <i :class="item.icon"></i>
                                {{item.title}}
                            </div>
                        </div>
                    </draggable>
                </div>
            </el-collapse-item>
        </el-collapse>
    </div>
</template>

<script>
import draggable from 'vuedraggable'
import bus from '@/components/common/bus';
import MaterialList from '@/components/decoration/material';
import OtherList from '@/components/decoration/other';
import { verificationAddCommon } from '@/components/decoration/constant';
export default {
    components: {
        draggable,
        bus,
    },
    data() {
        return {
            activeNames: ['1','2'],
            materialList: MaterialList,
            otherList: OtherList,
        };
    },
    methods:{
        // 点击添加
        pushComponent(item){
            bus.$emit('addRenderer',item)
        },
    }
};
</script>

<style scoped lang='scss'>
    .material{
        width: 100%;
        height: 100%;
        padding: 0 10px;
    }
    .basics{
        width: 100%;
        display: flex;
        .list{
            display: flex;
            flex-wrap: wrap;
            justify-content: left;
            width: 100%;
            padding: 10px 0 0 10px;
            .item{
                width: 80px;
                height: 80px;
                margin: 0 10px 10px 0;
                border-radius: 5px;
                transition: transform .2s;
                display: flex;
                justify-content: center;
                align-items: center;
                .renderer-status{
                    display: none;
                }
                .material-status{
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    i{
                        font-size: 28px;
                        color: rgb(64, 158, 255);
                        margin-bottom: 5px;
                    }
                }
                &:hover{
                    box-shadow: 0 0 5px 0 rgba(64, 158, 255,.3);
                    transform: scale(1.1);
                }
            }
        }
    }

    .ghost-view{
        .renderer-status{
            width: 350px;
            height: 40px;
            margin: 0 auto;
            color: #0256ff;
            background-color: #edf4fb;
            border: 1px dashed #0256ff;
            text-align: center;
            line-height: 40px;
        }
        .material-status{
            display: none;
        }
    }
</style>